import '../css/BrandsHome.css';
import { useQuery } from "@apollo/client";
import { GET_MEDIA_ITEM_BY_SLUG } from "../queries";
import { Flex } from 'antd';
import { useState } from 'react';
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl"

const MediaItem = ({ slug, page }) => {
  const [item, setItem] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.media?.[slug] || null;
  });

  const { loading, error } = useQuery(GET_MEDIA_ITEM_BY_SLUG, {
    variables: { slug },
    skip: !!item,
    onCompleted: (fetchedData) => {
      const mediaItem = fetchedData.mediaItemBy;
      const dataToLocal = {
        ...item,
        media: {
          [slug]: mediaItem,
        },
      }
      saveToLocalStorage(page, dataToLocal);
      setItem(mediaItem);
    },
  });

  return (
    <img loading="lazy" alt={(item?.altText || item?.title) || "Placeholder"} src={setImageAbsoluteUrl(item?.mediaItemUrl) || "placeholder.png"} />
  );
};

const BrandsHome = ({ page }) => {
  const slugs = [
    `brand-1-${page}`,
    `brand-5-${page}`,
    `brand-3-${page}`,
    `brand-4-${page}`,
    `brand-2-${page}`,
  ];

  return (
    <>
      <Flex 
        className='BrandsHome'>
        {slugs.map((slug, index) => (
          <MediaItem key={index} slug={slug} page={page} />
        ))}
      </Flex>
    </>
  );
};

export default BrandsHome;
